import { dragToCalendarText, dragInMailText } from './FRE.locstring.json';
import loc from 'owa-localize';
/* tslint:disable:jsx-no-lambda WI:47647 */
import FeatureExample from './FeatureExample';
import { observer } from 'mobx-react-lite';
import { LightningId } from 'owa-lightning-v2';
import { getOwaWorkload, OwaWorkload } from 'owa-workloads';
import * as React from 'react';

const FRE = observer(function FRE(props: {}) {
    return (
        <>
            <FeatureExample
                lid={LightningId.TodoCalendarFRE}
                when={lightup => getOwaWorkload() === OwaWorkload.Calendar && lightup()}
                gif={require('../resources/DragToCalendar.gif')}
                gifOverlayText={loc(dragToCalendarText)}
            />
            <FeatureExample
                lid={LightningId.TodoMailFRE}
                when={lightup => getOwaWorkload() === OwaWorkload.Mail && lightup()}
                gif={require('../resources/DragInMail.gif')}
                gifOverlayText={loc(dragInMailText)}
            />
        </>
    );
});
export default FRE;
